import {formatCpfCnpj} from "../formatter/format-cpf-cnpj"

export const getCompanyOptionLabel = (company) => {
    if (!company) return ""
    if (typeof company === "string") return company
    if (company.label && !company.RazaoSocial) return company.label

    const razaoSocial = company.RazaoSocial ?? company.nome ?? company.name ?? ""
    const cpfCnpjRaw = company.CPFCNPJ ?? company.formattedCPFCNPJ ?? company.value ?? ""
    const cpfCnpj = formatCpfCnpj(cpfCnpjRaw)

    return [razaoSocial, cpfCnpj].filter(Boolean).join(" ")
}